module.exports = __webpack_public_path__ + "img/check.7f7072af.svg";